import { getApi, postApi } from 'apis';

export type FamilyMemberStatus = 'Alive' | 'Deceased';
export type FamilyRelation =
	| 'Spouse'
	| 'SpouseDivorced'
	| 'Child'
	| 'Parent'
	| 'GrandParent'
	| 'Sibling';
export type FamilySide = 'maternal' | 'paternal' | 'none';

export const getFamilyMembers = async (
	employeeId: string,
	params: {
		search?: string;
		status?: 'Alive' | 'Deceased' | 'all';
		sort?: 'most_recent';
		limit?: number;
		offset?: number;
	}
) => {
	return await getApi(`/employee/employees/${employeeId}/family-members`, params);
};

export const addFamilyMember = async (
	employeeId: string,
	data: {
		name: string;
		relation: FamilyRelation;
		family_side: FamilySide;
		is_next_of_kin: boolean;
		mobile?: string | null;
		email?: string | null;
		date_of_birth: string;
	}
) => {
	return await postApi(`/employee/employees/${employeeId}/family-members`, data);
};

export const changeFamilyMemberStatus = async (
	employeeId: string,
	memberId: string,
	data: {
		new_status: FamilyMemberStatus;
		effective_date: string;
		notes: string;
	}
) => {
	return await postApi(
		`/employee/employees/${employeeId}/family-members/${memberId}/status`,
		data
	);
};

export const getFamilyMemberHistory = async (
	employeeId: string,
	memberId: string,
	params: { limit?: number; offset?: number }
) => {
	return await getApi(
		`/employee/employees/${employeeId}/family-members/${memberId}/history`,
		params
	);
};

export const familyHistoryApi = {
	getFamilyMembers,
	addFamilyMember,
	changeFamilyMemberStatus,
	getFamilyMemberHistory,
};
